<p-panel header="{{'notes_list_category_menu' | translate}}">
<app-category></app-category>
</p-panel>